import { render, staticRenderFns } from "./BaseParallaxe.vue?vue&type=template&id=6f14ffea&"
import script from "./BaseParallaxe.vue?vue&type=script&lang=js&"
export * from "./BaseParallaxe.vue?vue&type=script&lang=js&"
import style0 from "./BaseParallaxe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports